module.exports = __webpack_public_path__ + "img/doc-avatar-female.34ff7ecf.png";